<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (announcement) {
  <div class="mt-2">
    <ngb-alert type="info">
      @if (announcement.avisTyp === CorporateActionType.TEILRECHT) {
        <bezugsrecht-announcement-list-item-teilrecht [announcement]="announcement" />
      }
      @if ([CorporateActionType.WDIF, CorporateActionType.WDIV].includes(announcement.avisTyp)) {
        <bezugsrecht-announcement-list-item-wahldividende [announcement]="announcement" />
      }
      @if (![CorporateActionType.TEILRECHT, CorporateActionType.WDIF, CorporateActionType.WDIV].includes(announcement.avisTyp)) {
        <bezugsrecht-announcement-list-item-kap [announcement]="announcement" />
      }
    </ngb-alert>
  </div>
}
